import { createActions, createReducer } from 'reduxsauce'

import DespesasPorCredorService from '../../servicos/DespesasPorCredorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaOperacoesDespesasInicio: [],
    buscaOperacoesDespesasSucesso: ['operacoesDespesas'],
    buscaOperacoesDespesasErro: ['erro'],
    setSelecionadoOperacoesDespesasSucesso: ['selecionado'],
    setOperacoesDespesasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaOperacoesDespesas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaOperacoesDespesasInicio())
        let serv = new DespesasPorCredorService()
        let data = {
            administracao: filtro.administracoes ? filtro.administracoes.map(e => e.value).join() : '',
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            mes: filtro.mes ? filtro.mes.value : '',
            recursoContabil: filtro.recursos ? filtro.recursos.map(e => e.value).join() : '',
            codigoDestinacao: filtro.destinacoes ? filtro.destinacoes.map(e => e.value).join() : '',
            stnModelo: filtro.sequencia.modelo,
            stnSequencia: filtro.sequencia.sequencia,
        }
        return serv
            .consultarIndependente(data)
            .then(response => dispatch(Creators.buscaOperacoesDespesasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaOperacoesDespesasErro(error)))
    }
}

const buscaOperacoesDespesasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaOperacoesDespesasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaOperacoesDespesasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.operacoesDespesas.resultado, dataSincronizacaoDados: action.operacoesDespesas.dataAtualizacaoDados, carregando: false }
}

const setSelecionadoOperacoesDespesasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setOperacoesDespesasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_OPERACOES_DESPESAS_INICIO]: buscaOperacoesDespesasInicio,
    [Types.BUSCA_OPERACOES_DESPESAS_ERRO]: buscaOperacoesDespesasErro,
    [Types.BUSCA_OPERACOES_DESPESAS_SUCESSO]: buscaOperacoesDespesasSucesso,
    [Types.SET_SELECIONADO_OPERACOES_DESPESAS_SUCESSO]: setSelecionadoOperacoesDespesasSucesso,
    [Types.SET_OPERACOES_DESPESAS_ESTADO_DT]: setOperacoesDespesasEstadoDT,
})
